import { FabricInitializeUI } from '@idmc-ms-fabric/integration';
import ReactDOM from 'react-dom';

import App from './App';

const initializeUI: FabricInitializeUI = async () => {
	ReactDOM.render(<App />, document.querySelector('#root'));
};

export default initializeUI;
